import React from 'react';
import {useVideoRoomEventFor} from "./utils";
import {chain, range} from 'lodash';
import {useSelector} from "react-redux";
import BetOption from "./bet_option";
import "./bet_overlay.scss"

const BetOptions = ({bet}) => {
  const availableBetOptions = chain(range(1, 11))
    .map(betOptionNumber => {
      return {
        optionNumber: betOptionNumber,
        enabled: bet[`bet_option_${betOptionNumber}_enabled`],
        value: bet[`bet_option_${betOptionNumber}_value`],
        label: bet[`bet_option_${betOptionNumber}_label`],
        min: bet[`bet_option_${betOptionNumber}_min`],
        max: bet[`bet_option_${betOptionNumber}_max`],
        steps: bet[`bet_option_${betOptionNumber}_steps`],
        correct: bet[`bet_option_${betOptionNumber}_correct`],
        priority: bet[`bet_option_${betOptionNumber}_priority`],
        rate: bet[`bet_option_${betOptionNumber}_rate`],
      }
    })
    .sortBy(['priority', 'id'])
    .reverse()
    .filter((betOption) => betOption.enabled)
    .value()


  return <div className={"bet-overlay-container"}>
    <div className="row">
      <div className="col-12">
        <div className="bet-question">
          {bet.title}
        </div>
      </div>
      {availableBetOptions.map(betOption => {
        return <div key={betOption.optionNumber} className={"col-12 col-md-6"}>
          <BetOption
            option={betOption.optionNumber}
            betId={bet.id}>
            {betOption.label}
          </BetOption>
        </div>
      })}
    </div>
  </div>
}

const BetOverlay = ({videoRoom, overrideEvent}) => {
  const betsFromEvent = useVideoRoomEventFor(videoRoom, videoRoom.take_bets_from, overrideEvent)

  const bets = useSelector(state => state.bets)

  const targetBet = chain(bets)
    .sortBy(['priority', 'id'])
    .reverse()
    .filter((bet) => bet.visible && !bet.archived && bet.event_id === betsFromEvent.id)
    .value()[0]

  if (!targetBet || !videoRoom.votings_enabled || videoRoom.voting_render_type !== "overlay") {
    return null
  }

  return <BetOptions bet={targetBet}/>
}

export default BetOverlay